module.exports = new __parcel__URL__("64695_h.af81e784.jpg").toString();